export default {
	methods: {
		get_data(data, metadata) {
			for (let s = 0; s < metadata.length; s++) {
				if (metadata[s].id == data) return metadata[s].value;
			}
			return data;
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/sst/seguranca/components/mapRisco/js/getData.mixins.js